module.exports = __webpack_public_path__ + "img/imago-prosegur@3x.730b686f.png";